import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, ViewChild, TemplateRef } from '@angular/core';
import { DatePipe } from '@angular/common';
import {
    NgFlowchartCanvasDirective,
    NgFlowchartStepRegistry,
    NgFlowchart,
    NgFlowchartStepComponent
  } from '@joelwenzel/ng-flowchart';
import { InteractService } from 'app/BaseFramework';

@Component({
    selector: 'app-policy-issuence-step',
    templateUrl: './policy-issuence-step.component.html',
    providers: [DatePipe]
})
export class PolicyIssuenceStepComponent extends NgFlowchartStepComponent implements OnInit {

    stepName:any = 'State'
    statusDescription=null
    constructor(public interactService: InteractService){
      super();

    }

    ngOnInit(){
      this.stepName = this.data.name
    }
    _currentComponentName = 'StatusStep'

    title = 'workspace';

    getDropPositionsForStep(pendingStep: NgFlowchart.PendingStep): NgFlowchart.DropPosition[] {
        return ['ABOVE', 'LEFT', 'RIGHT', 'BELOW'];
    }

    checkData(data){
      console.log(data);
      
    }
  
    // Modal Methods
    isVisible = false;
  isOkLoading = false;

  showModal(): void {
    this.isVisible = true;
  }

  handleOk(data): void {
    this.data.name = this.stepName
    if(this.stepName !== 'DataEntry'){
      this.interactService.broadcast({
        actionPerformed:'DataEntryChanged',
        guid:this.data.guid
      })
    }
    this.isOkLoading = true;
    setTimeout(() => {
      this.isVisible = false;
      this.isOkLoading = false;
    }, 500);
  }

  handleCancel(data): void {
    console.log(data);
    
    this.isVisible = false;
  }

  deleteStep(id?){
    this.interactService.broadcast({
      actionPerformed:'Delete',
      id:this.id
    })
  }

  node = {
    id: 'node1',
    name: 'Node 1',
    x: 100,
    y: 100
  };
  
}